import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const PERCENT = 100

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, max = PERCENT, ...props }, ref) => {
  const indicatorStyle = React.useMemo(
    () => ({ transform: `translateX(-${PERCENT - ((value || 0) / max) * PERCENT}%)` }),
    [value, max]
  )
  return (
    <ProgressPrimitive.Root
      ref={ref}
      value={value}
      max={max}
      className={cn(
        "relative h-2.5 w-full overflow-hidden rounded-full bg-muted/50",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="size-full flex-1 bg-gradient-to-r from-primary to-success transition-transform duration-500 motion-reduce:transition-none"
        style={indicatorStyle}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
